import { PixelBuffer } from "../pixel/PixelBuffer";
import type { Selection } from "../selection/Selection";
import type { Filter } from "./Filter";

export interface CrystallizeParams {
  cellSize: number;
}

export const Crystallize: Filter<CrystallizeParams> = {
  id: "crystallize",
  displayName: "Crystallize",
  defaultParams: { cellSize: 10 },

  apply(input: PixelBuffer, params: CrystallizeParams, _selection: Selection | null): PixelBuffer {
    const w = input.width;
    const h = input.height;
    const out = new PixelBuffer(w, h, input.mode);
    const src = input.data;
    const dst = out.data;

    if (w === 0 || h === 0 || params.cellSize < 2) { dst.set(src); return out; }

    const size = Math.round(params.cellSize);
    const centers: Array<{ x: number; y: number }> = [];

    for (let y = 0; y < h; y += size) {
      for (let x = 0; x < w; x += size) {
        centers.push({ x: x + size / 2, y: y + size / 2 });
      }
    }

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        let minDist = Infinity, closestX = 0, closestY = 0;
        for (const c of centers) {
          const dx = x - c.x, dy = y - c.y;
          const d = dx * dx + dy * dy;
          if (d < minDist) { minDist = d; closestX = c.x; closestY = c.y; }
        }

        const o = (y * w + x) * 4;
        const si = (Math.round(closestY) * w + Math.round(closestX)) * 4;
        if (si >= 0 && si < src.length) {
          dst[o] = src[si]!; dst[o + 1] = src[si + 1]!; dst[o + 2] = src[si + 2]!; dst[o + 3] = src[si + 3]!;
        }
      }
    }
    return out;
  },
};
